import { CSSProperties, ReactNode } from 'react';

export type PillTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'accent';
export type PillVariant = 'dot' | 'soft' | 'solid';

export interface PillProps {
  tone?: PillTone;
  variant?: PillVariant;
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
}

export function Pill({
  tone = 'neutral',
  variant = 'dot',
  children,
  style,
  className,
}: PillProps) {
  const cls = [
    'ds-pill',
    `ds-pill-${tone}`,
    variant === 'soft' ? 'ds-pill-soft' : '',
    variant === 'solid' ? 'ds-pill-solid' : '',
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={cls} style={style}>
      {variant === 'dot' && <span className="ds-pill-dot" aria-hidden="true" />}
      {children}
    </span>
  );
}

export default Pill;
